import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "chevron-up_svg__icon chevron-up_svg__icon--chevron-up"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.28 15.78a.75.75 0 0 1-1.06 0l-6.97-6.97-6.97 6.97a.75.75 0 1 1-1.06-1.06l7.146-7.147a1.25 1.25 0 0 1 1.768 0l7.146 7.147a.75.75 0 0 1 0 1.06Z",
    clipRule: "evenodd"
  })));
};

export { SvgChevronUp as default };
//# sourceMappingURL=chevron-up.svg.js.map
